import { Legacyprofile as LegacyprofileData } from '@/payload-types'
import { LegacyProfileCardComponent } from '@/components/legacy-profile-profile-card/profileCard'
interface IProps {
  profileData: (string | null) | LegacyprofileData
}

export const LegacyFeaturedPostProfileCardComponent = ({ profileData }: IProps) => {
  return (
    <div className={'mb-6 pb-8 divider'}>
      <LegacyProfileCardComponent
        profileData={profileData}
        profilePicture={{
          pictureDivCSS: 'w-28 h-28',
          pictureCSS: 'rounded-full shadow-md default-border',
        }}
        profileFullName={{ fullNameDivCSS: 'my-3', fullNameCSS: 'font-bold leading-[27px] text-xl' }}
        profileDescription={{ ifShow: true, descCSS: 'text-sm font-medium line-clamp-[15]' }}
        seeProfileBtn={{ ifShow: true, btnCSS: 'shadow-btn mt-3' }}
      />
    </div>
  )
}

export default LegacyFeaturedPostProfileCardComponent
